 
export default {
  color: "text",
  variants: {
    logo: {
      color: "primary.500",
      fontSize: "84px",
    },
  },
};
